import { Capacitor } from '@capacitor/core';
import logger from './logger';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

export async function initNativeFeatures() {
  if (!isNative) return;

  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark });
    if (platform === 'android') {
      await StatusBar.setBackgroundColor({ color: '#1A3A4A' });
    }
  } catch (e) {
    logger.log('StatusBar not available');
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide();
  } catch (e) {
    logger.log('SplashScreen not available');
  }

  try {
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
  } catch (e) {
    logger.log('App plugin not available');
  }
}

export async function triggerHaptic(type = 'light') {
  if (!isNative) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    const styles = {
      light: ImpactStyle.Light,
      medium: ImpactStyle.Medium,
      heavy: ImpactStyle.Heavy,
    };
    await Haptics.impact({ style: styles[type] || ImpactStyle.Light });
  } catch (e) { /* Haptics not available on web - expected */ console.debug('Haptics unavailable:', e.message); }
}

export async function nativeShare(title, text) {
  if (!isNative) return false;
  try {
    const { Share } = await import('@capacitor/share');
    await Share.share({ title, text, dialogTitle: title });
    return true;
  } catch (e) {
    return false;
  }
}
